import React, { Component} from "react";
import { Row } from "reactstrap";


class Features extends Component{
    render(){
        const {nbrPerson,AC,energie} = this.props
        return(
            <Row>
                <div className="d-flex featureCont">
                    <img className="cardIcon mr-1" src="/imgs/cardIcons/place.png" alt='features'/>
                    <p className="featureNbr align-self-center mr-1">{nbrPerson}</p>
                </div>
                <div className="d-flex featureCont">
                    <p className="featureNbr align-self-center mr-1">{energie}</p>
                </div>
                {AC &&
                <div className="d-flex featureCont">
                    <img className="cardIcon mr-1 ml-1" src="/imgs/cardIcons/AC.png" alt='features3'/>
                </div>
                }
                
            </Row>
        )
    }
}

export default Features;